import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { useGlobal } from '@/utils/useGlobal';

interface BarProps {
    pageType: 'ultra' | 'max';
}

const Bar: React.FC<BarProps> = ({ pageType }: BarProps = { pageType: 'max' }) => {
    const { getSystemTime } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('Bar');

    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const endTime = new Date('2025/12/31 23:59:59 GMT+8').getTime();

    const imgMap = {
        max: {},
        ultra: {
            us: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1765851990876-dbdm5o-compressed-PC%E5%88%87%E5%9B%BE.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1765852010154-ev919k-compressed-m%E5%88%87%E5%9B%BE.jpg',
            },
        },
    };

    const imgResMap = imgMap[pageType as keyof typeof imgMap][isEU ? 'eu' : 'us'];

    const systemTime = getSystemTime();
    if (systemTime >= endTime) return null;

    return (
        <div className={`${styles.Bar} GtmModuleData-section`} data-section-id="d3m-bar">
            <EcoLink href={'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?view=d3up&variant=54718705008713'} className="bar-link">
                <EcoImg className="img-bg" pc={imgResMap?.pc} h5={imgResMap?.h5} />
                <div className="footer-desc-container">
                    <span className="footer-desc">{t('footer_desc')}</span>
                    <span className="btn">{t('btn')}</span>
                </div>
            </EcoLink>
        </div>
    );
};

export default Bar;
